import { render, staticRenderFns } from "./manualOrdering.vue?vue&type=template&id=4eb12a28&scoped=true&"
import script from "./manualOrdering.vue?vue&type=script&lang=js&"
export * from "./manualOrdering.vue?vue&type=script&lang=js&"
import style0 from "./manualOrdering.vue?vue&type=style&index=0&id=4eb12a28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb12a28",
  null
  
)

export default component.exports